import { defineStore } from 'pinia'
import { getAllOrders } from '@/api/orders/getAllOrders'
import { createOrder } from '@/api/orders/createOrder'

interface OrderStore {
  orders: any[]
  products: any[]
  loading: boolean
  totalItems: number
}

export const useOrdersStore = defineStore('orders', {
  state: (): OrderStore => ({
    orders: [],
    products: [],
    loading: false,
    totalItems: 0
  }),

  getters: {
    tables: (state) => {
      const tableMap = new Map<string, any[]>()

      state.orders.forEach((order) => {
        const tablenumMeta = order.meta_data.find((meta: any) => meta.key === 'tablenum')
        const tablenum = tablenumMeta ? tablenumMeta.value : 'unknown'

        if (!tableMap.has(tablenum)) {
          tableMap.set(tablenum, [])
        }
        tableMap.get(tablenum)?.push(order)
      })

      return Array.from(tableMap, ([tablenum, orders]) => ({ tablenum, orders }))
    }
  },

  actions: {
    async getOrders() {
      this.loading = true
      const { data, success } = await getAllOrders()
      if (success) {
        this.orders = data.orders
        this.totalItems = data.total_items
        this.loading = false
      }
      return {
        success
      }
    },

    async createTable(payload: any) {
      const newTable = await createOrder(payload)
      this.orders.unshift(newTable.data)
    }
  }
})
